import { Item } from '../../common/snippets'
import { AcountingHeading } from './common/AcountingHeading'
import { Box, Button } from '@mui/material'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import { useState } from 'react'
import moment from 'moment'
import { focusElemnt } from '../../common/helper'
import useToken from '../../helpers/useTokens'
import { profileLossCriteriaHeaders, profitLossHeaders } from './contants'
import { GetRequest } from '../../common/api'
import { urls } from '../../common/constants'
import { useSetAtom } from 'jotai'
import { alertAtom, globalLoaderAtom } from '../../common/jotaiState/globalStateAtoms'
import { roundOff, safeAdd } from '../../common/mathHelper'
import { useSearchParams } from 'react-router-dom'
import { downloadPDF } from '../Reports/analysisReport/pdfAutotable'
const reportName = 'Vehicle Profit and Loss Report'
export const ProfileLossReport = () => {
  const setLoader = useSetAtom(globalLoaderAtom)
  const setAlert = useSetAtom(alertAtom)
  let { loginData = {} } = useToken()
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [vehicleList, setVehicleList] = useState([])
  const [selectedVehicle, setSelectedVehicle] = useState()
  const [tableData, setTableData] = useState([])
  const [searchParams] = useSearchParams()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = searchParams.get('C') || 0
    loginData.intUserID = searchParams.get('U') || 0
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, strCompanyName } = loginData
  const headers = profitLossHeaders.map((col) => ({
    ...col,
    align: col.align || col.xlCol?.dataType === 'quantity' ? 'right' : 'left',
    exportHead: col.header,
  }))
  const fetchFilters = () => {
    setLoader(true)
    const data = {
      intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
    }
    GetRequest(urls.getProfitAndLossReportFilter, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const vehicleList = res.Data.Table
        if (vehicleList.length > 1) {
          vehicleList.unshift({ VehicleID: 0, VehicleNo: 'All Vehicles' })
        }
        setVehicleList(vehicleList)
        setSelectedVehicle(vehicleList[0])
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const fetchTableData = (isPdf = false) => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selectedVehicle?.VehicleID === 0
    if (isAllSelected && diffDays > 15) {
      setAlert({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (!isAllSelected && diffDays > 31) {
      setAlert({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    } else if (!selectedVehicle?.VehicleNo) {
      setAlert({ show: true, msg: 'Please select vehicle', nextId: '' })
      return
    }
    setLoader(true)
    const data = {
      intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
      VehicleID: selectedVehicle.VehicleID,
    }
    GetRequest(urls.getProfitAndLossReport, data)
      .then((res) => {
        if (res.status !== 'Success') {
          throw new Error(res?.ErrMessage || 'Request Failed')
        }
        if (!Array.isArray(res.Data.Table) || res.Data.Table.length === 0) {
          throw new Error('No Data Found')
        }
        const data = formatTableData(res.Data.Table, res.Data.Table1, headers)
        if (isPdf === true) {
          downloadPDF({
            reportName,
            criteriaHeaders: profileLossCriteriaHeaders,
            criteriaData: [criteriaData],
            tableData: data,
            visibleColumns: headers,
            loginData,
            hideHeader: false,
          })
          return
        }
          const reportPayload = {
                      reportName,
                      criteriaHeaders: profileLossCriteriaHeaders,
                      criteriaData: [criteriaData],
                      tableData: data,
                      mainHeader: headers,
                      totalColspanKey:'TotalNetAmount',
                      serialNokey :'SN',
                    }
        
                    const rid = Date.now().toString()
        
                    if (!window.generatedReports) {
                      window.generatedReports = {}
                    }
        
                    window.generatedReports[rid] = reportPayload
        
                    window.open(`/view-report?rid=${rid}`, "_blank")
      })
      .catch((err) => {
        setAlert({ show: true, msg: err.message, nextId: '' })
      })
      .finally(() => setLoader(false))
  }
  const formatTableData = (list, list1, headers) => {
    const firstCol = headers[0].field
    const TOTAL_FIELD = headers[headers.length - 1].field
    const entries = list.map((row, index) => ({
      ...row,
      SN: index + 1,
      dataType: 'entry',
      disabled: true,
      DispatchDate: moment(row.DispatchDate).format('DD-MM-YYYY'),
    }))
    const dateMap = entries.reduce((acc, row) => {
      acc[row.DispatchDate] ||= []
      acc[row.DispatchDate].push(row)
      return acc
    }, {})

    const result = []
    let grandProfitLoss = 0

    Object.entries(dateMap).forEach(([date, dateRows]) => {
      const vehicleMap = dateRows.reduce((acc, row) => {
        acc[row.VehicleNo] ||= []
        acc[row.VehicleNo].push(row)
        return acc
      }, {})

      let dayNetTotal = 0

      Object.entries(vehicleMap).forEach(([vehicleNo, vehicleRows]) => {
        result.push(...vehicleRows)

        const vehicleNetTotal = vehicleRows.reduce((sum, r) => safeAdd(sum, r[TOTAL_FIELD], 4), 0)

        dayNetTotal += vehicleNetTotal

        result.push({
          dataType: 'total',
          [firstCol]: `Net Amount | ${vehicleNo}`,
          align: { [firstCol]: 'right' },
          colSpan: { [firstCol]: headers.length - 1 },
          [TOTAL_FIELD]: vehicleNetTotal,
        })
      })

      result.push({
        dataType: 'total',
        [firstCol]: `Total Net Amount | All Vehicles | ${date}`,
        align: { [firstCol]: 'right' },
        colSpan: { [firstCol]: headers.length - 1 },
        [TOTAL_FIELD]: dayNetTotal,
      })
      const daySummary = list1.find((item) => moment(item.TransDate).format('DD-MM-YYYY') === date)
      const { HireCharges = 0, TDS = 0, GSTAmount = 0 } = { ...daySummary }
      result.push(
        {
          dataType: 'subHeader',
          [firstCol]: `Total Hire Charges from Due Report | ${date}`,
          align: { [firstCol]: 'right', [TOTAL_FIELD]: 'right' },
          colSpan: { [firstCol]: headers.length - 1 },
          [TOTAL_FIELD]: `${roundOff(HireCharges) > 0 ? '-' : ' '}${roundOff(HireCharges)}`,
        },
        {
          dataType: 'subHeader',
          [firstCol]: `Total TDS from Due Report | ${date}`,
          align: { [firstCol]: 'right', [TOTAL_FIELD]: 'right' },
          colSpan: { [firstCol]: headers.length - 1 },
          [TOTAL_FIELD]: `${roundOff(TDS) > 0 ? '-' : ' '}${roundOff(TDS)}`,
        },
        {
          dataType: 'subHeader',
          [firstCol]: `Total GST from Booking Summary | ${date}`,
          align: { [firstCol]: 'right', [TOTAL_FIELD]: 'right' },
          colSpan: { [firstCol]: headers.length - 1 },
          [TOTAL_FIELD]: `${roundOff(GSTAmount) > 0 ? '-' : ' '}${roundOff(GSTAmount)}`,
        }
      )

      const dayProfitLoss = dayNetTotal - HireCharges - TDS - GSTAmount
      grandProfitLoss += dayProfitLoss

      result.push({
        dataType: 'total',
        [firstCol]: `Net Amount - Profit / Loss | All Vehicles | ${date}`,
        align: { [firstCol]: 'right' },
        colSpan: { [firstCol]: headers.length - 1 },
        [TOTAL_FIELD]: roundOff(dayProfitLoss),
      })
    })

    result.push({
      dataType: 'total',
      [firstCol]: `Net Amount - Profit / Loss | All Dates`,
      align: { [firstCol]: 'right' },
      colSpan: { [firstCol]: headers.length - 1 },
      [TOTAL_FIELD]: roundOff(grandProfitLoss),
    })

    return result
  }

  const criteriaData = {
    fromDate: fromDate.format('DD-MM-YYYY'),
    toDate: toDate.format('DD-MM-YYYY'),
    vehicle: selectedVehicle?.VehicleNo || '',
    dataType: 'entry',
  }

  return (
    <Item sx={{ padding: '0' }} className="reports">
      {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
      {isFromUrl ? <></> : <AcountingHeading reportName={reportName.slice(0, -7)} />}
      <Box sx={sx.reportFlex}>
        {isFromUrl ? <></> : <Item sx={sx.itemsx}>
          <DropDownOA
            id={id.selectCompany}
            label={lb.select_company}
            defaultvalue={strCompanyName}
            disabled={true}
            minWidth="250px"
          />
        </Item>}

        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            name={'from_date'}
            id={id.fromDate}
            value={fromDate}
            dateChange={(date) => {
              setFromDate(date)
              focusElemnt(id.toDate)
            }}
            width={isFromUrl ? '100%' : '210px'}
          />
        </Item>
          <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker" >
          <Datepicker
            label={'To Date'}
            name={'to_date'}
            id={id.toDate}
            value={toDate}
            dateChange={(date) => {
              setToDate(date)
              focusElemnt('buttonGo')
            }}
            width={isFromUrl ? '100%' : '210px'}
          />
        </Item>
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonGo"
            onClick={fetchFilters}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            GO
          </Button>
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
          <DropDownOA
            id={id.srcCity}
            label={lb.selectVehicle}
            data={vehicleList}
            defaultvalue={selectedVehicle?.VehicleNo || ''}
            value={selectedVehicle?.VehicleNo || ''}
            idKey={`VehicleID`}
            dataKey={`VehicleNo`}
            onSelect={setSelectedVehicle}
            searchPlaceholder={`Search Vehicle`}
            width={isFromUrl ? '100%' : '250px'}
            nextId={id.selectBranches}
            prevId={id.stateId}
          />
        </Item>
        {isFromUrl ? <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary"  onClick={() => fetchTableData(true)} id="buttonLoad">
          DOWNLOAD PDF
        </Button> : 
        <Item sx={sx.itemsx} className="disabled-wrapper">
          <Button
            id="buttonLoad"
            onClick={fetchTableData}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp }}
            className="btn btn-primary"
          >
            Load
          </Button>
        </Item>}
      </Box>
    </Item>
  )
}
